import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, parseISO, isValid } from "date-fns";

const CustomDatePicker = ({
  label,
  value,
  onChange,
  error,
  placeholder = "Select Date",
  minDate,
  maxDate,
  className = "",
  labelClassName = "",
  disabled = false,
  required = false,
  ...props
}) => {
  // Handle string values from backend/state and convert to Date objects for react-datepicker
  const selectedDate = value
    ? typeof value === "string"
      ? parseISO(value)
      : value
    : null;

  // Safe date check
  const dateValue = selectedDate && isValid(selectedDate) ? selectedDate : null;

  const handleChange = (date) => {
    if (!date) {
      onChange("");
      return;
    }
    // Convert back to string format (YYYY-MM-DD) for consistency with existing state handlers
    const formattedDate = format(date, "yyyy-MM-dd");
    onChange(formattedDate);
  };

  return (
    <div className={`space-y-1 ${className}`}>
      {label && (
        <label
          className={`block text-[11px] font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400 ${labelClassName}`.trim()}
        >
          {label} {required && <span className="text-rose-500">*</span>}
        </label>
      )}
      <div className="relative">
        <DatePicker
          selected={dateValue}
          onChange={handleChange}
          dateFormat="dd/MM/yyyy"
          placeholderText={placeholder}
          minDate={
            minDate
              ? typeof minDate === "string"
                ? parseISO(minDate)
                : minDate
              : null
          }
          maxDate={
            maxDate
              ? typeof maxDate === "string"
                ? parseISO(maxDate)
                : maxDate
              : null
          }
          disabled={disabled}
          autoComplete="off"
          className={`w-full rounded-lg border px-3 py-1.5 text-xs focus:outline-none transition-all
            ${
              error
                ? "border-rose-500 ring-2 ring-rose-500/20 focus:border-rose-500"
                : "border-slate-200 bg-white focus:border-primary-500 focus:ring-2 focus:ring-primary-500/20 dark:border-slate-800 dark:bg-slate-900 dark:text-slate-100 dark:focus:border-primary-dark dark:focus:ring-primary-dark/20"
            }
            ${disabled ? "cursor-not-allowed bg-slate-50 opacity-60 dark:bg-slate-800" : ""}
          `}
          {...props}
        />
        <div className="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none text-slate-400">
          <svg
            className="h-3.5 w-3.5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
        </div>
      </div>
      {error && (
        <p className="mt-1 text-[10px] font-bold text-rose-500 uppercase leading-tight">
          {error}
        </p>
      )}
    </div>
  );
};

export default CustomDatePicker;
